export default __webpack_public_path__ + "static/media/ビザ・パスポート情報.bca51013.pdf";